export default [
  {
    path: '/doc/modal',
    component: 'Docs/Modal',
    exact: true
  },
  {
    path: '/doc/content',
    component: 'Docs',
    exact: true
  },
  {
    path: '/yggj-download',
    title: '购管家app下载',
    component: 'YggjAppDownload',
    exact: true
  },
  {
    path: '/download/hk',
    title: '购管家app下载',
    component: 'YggjAppDownload',
    exact: true
  },
  {
    path: '/app_download',
    title: '应用下载',
    component: 'AppDownload',
    exact: true
  },
  {
    path: '/download/app',
    title: '应用下载',
    component: 'AppDownload',
    exact: true
  },
  {
    path: '/app_download_sms',
    title: '应用下载',
    component: 'AppDownload',
    exact: true
  },
  {
    path: '/submit_complaint',
    title: '申诉问题提交',
    component: 'SubmitComplaint',
    exact: true
  },
  {
    path: '/material',
    title: '素材详情',
    component: 'MaterialDetail',
    exact: true
  },
  {
    path: '/invokeapp',
    title: '打开app中转页',
    component: 'Invokeapp',
    exact: true
  },
  {
    path: '/doc/topic/talk-rule',
    title: '话题打卡活动规则说明',
    component: 'Docs/TopicTalk',
    exact: true
  },
  {
    path: '/alipay',
    title: '支付宝代付',
    component: 'Alipay',
    exact: true
  },
  {
    path: '/tx-captcha',
    component: 'TencentCaptcha'
  },
  {
    path: '/help',
    title: '帮助中心',
    component: 'Help',
    exact: true,
    routes: [
      {
        path: '/help/list',
        title: '帮助列表',
        component: 'Help/HelpList',
        exact: true
      },
      {
        path: '/help/detail',
        title: '帮助详情',
        component: 'Help/HelpDetail',
        exact: true
      }
    ]
  },
  {
    path: '/order-ticket',
    component: 'OrderTicket'
  }
];
